import { graphql } from 'react-relay';

export default graphql`
  query successQuery($packageId: Int!) {
    privatePackageTracker(packageId: $packageId) {
      destinationInfo {
        firstLine
        secondLine
        complement
        coordinates {
          lat
          lng
        }
        classificationType
        instructions
        additionalReceivers
      }
      permissions
    }
  }
`;
